import * as yup from "yup";

import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";
export type SetBacksInspectionFormProps = {
    id: string;
    returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: SetBacksInspectionInput;
    action: "post" | "put";
};

export type SetBacksInspectionInput = {

    setBackId: number
    applicationId: number;
    applicationInspectionId: number;
    surfaceWaterComplianceId: number;
    surfaceWaterCompliance?: ComplianceOptions;
    surfaceWaterComment: string;
    surfaceWater: string;
    ditchesComplianceId: number;
    ditchesCompliance?: ComplianceOptions;
    ditchesComment: string;
    ditches: string;
    privateWellsComplianceId: number;
    privateWellsCompliance?: ComplianceOptions;
    privateWellsComment: string;
    privateWells: string;
    publicWellsComplianceId: number;
    publicWellsCompliance?: ComplianceOptions;
    publicWellsComment: string;
    publicWellsLessThan2000GPD: string;
    publicWellsGreaterThan2000GPD: string;
    irrigationWellsComplianceId: number;
    irrigationWellsCompliance?: ComplianceOptions;
    irrigationWellsComment: string;
    irrigationWells: string;
    portableWaterLinesComplianceId: number;
    portableWaterLinesCompliance?: ComplianceOptions;
    portableWaterLinesComment: string;
    portableWaterLines: string;
    scheduled40Pvc?: string;
    sleevedSealed?: string;
    buildingFoundationComplianceId: number;
    buildingFoundationCompliance?: ComplianceOptions;
    buildingFoundationComment: string;
    buildingFoundation: string;
    propertyLinesComplianceId: number;
    propertyLinesCompliance?: ComplianceOptions;
    propertyLinesComment: string;
    propertyLines: string;
    otherComplianceId: number;
    otherCompliance?: ComplianceOptions;
    otherComment: string;
    otherDescription: string;
    otherSetback: string;
    dateCreated: Date | string;
    createdBy: string;
    dateUpdated: Date | string;
    updatedBy: string;
    markAll: number;
    inspectionStatusId: number;

};
export type ComplianceData = {
    id: number;
    name: string;

};

export const schema = yup.object().shape({

    surfaceWaterComplianceId: yup
        .number()
        .min(1, "Surface Water Compliance is required")
        .required("Surface Water Compliance is required")
        .typeError("Surface Water Compliance is required"),
    surfaceWater: yup.string().nullable(true)
    .when("surfaceWaterComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .required("Surface Water(ft) is required")
        .typeError("Surface Water(ft) should be numeric"),
    }),
    surfaceWaterComment: yup.string().nullable(true)
        .when("surfaceWaterComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string()
                .required("Surface Water Comment is required")
                .typeError("Surface Water Comment is required"),
        }),
    ditchesComplianceId: yup
        .number()
        .min(1, "Ditches Compliance is required")
        .required("Ditches Compliance is required")
        .typeError("Ditches Compliance is required"),
    ditches: yup.string().nullable(true)
    .when("ditchesComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Ditches(ft) should be numeric")
        .required("Ditches(ft) is required"),
    }),
    ditchesComment: yup.string().nullable(true)
        .when("ditchesComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Ditches Comment is required")
                .typeError("Ditches Comment is required"),
        }),
    privateWellsComplianceId: yup
        .number()
        .min(1, "Private Wells Compliance is required")
        .required("Private Wells Compliance is required")
        .typeError("Private Wells Compliance is required"),
    privateWells: yup.string().nullable(true)
    .when("privateWellsComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Private Wells(ft) should be numeric")
        .required("Private Wells(ft) is required"),
    }),
    privateWellsComment: yup.string().nullable(true)
        .when("privateWellsComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Private Wells Comment is required")
                .typeError("Private Wells Comment is required"),

        }),
    publicWellsComplianceId: yup
        .number()
        .min(1, "Public Wells Compliance is required")
        .required("Public Wells Compliance is required")
        .typeError("Public Wells Compliance is required"),
    publicWellsLessThan2000GPD: yup.string().nullable(true)
    .when("publicWellsComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Public Wells >2000 gpd (ft) should be numeric")
        .required("Public Wells >2000 gpd (ft) is required"),
    }),
    publicWellsGreaterThan2000GPD: yup.string().nullable(true)
    .when("publicWellsComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Public Wells <=2000 gpd (ft) should be numeric")
        .required("Public Wells <=2000 gpd (ft) is required"),
    }),
    publicWellsComment: yup.string().nullable(true)
        .when("publicWellsComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Public Wells Comment is required")
                .typeError("Public Wells Comment is required"),
        }),


    irrigationWellsComplianceId: yup
        .number()
        .min(1, "Irrigation Wells Compliance is required")
        .required("Irrigation Wells Compliance is required")
        .typeError("Irrigation Wells Compliance is required"),
    irrigationWells: yup.string().nullable(true)
    .when("irrigationWellsComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Irrigation Wells(ft) should be numeric")
        .required("Irrigation Wells(ft) is required"),
    }),
    irrigationWellsComment: yup.string().nullable(true)
        .when("irrigationWellsComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Irrigation Wells Comment is required")
                .typeError("Irrigation Wells Comment is required"),
        }),
    portableWaterLinesComplianceId: yup
        .number()
        .min(1, "Potable Water Lines Compliance is required")
        .required("Potable Water Lines Compliance is required")
        .typeError("Potable Water Lines Compliance is required"),
    portableWaterLines: yup.string().nullable(true)
    .when("portableWaterLinesComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Potable Water Lines(ft) should be numeric")
        .required("Potable Water Lines(ft) is required"),
    }),
    portableWaterLinesComment: yup.string().nullable(true)
        .when("portableWaterLinesComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Potable Water Lines Comment is required")
                .typeError("Potable Water Lines Comment is required"),
        }),
    sleevedSealed: yup.string().nullable(true)
        .when("portableWaterLinesComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
            then: yup.string().oneOf(["Yes", "No"], "Sleeved? is required")
            .required("Sleeved? is required")
                .typeError("Sleeved? is required"),
        }),
    scheduled40Pvc: yup.string().nullable(true)
        .when("portableWaterLinesComplianceId", {
            is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
            then: yup.string().oneOf(["Yes", "No"], "Schedule 40 PVC? is required")
            .required("Schedule 40 PVC? is required")
                .typeError("Schedule 40 PVC? is required"),
        }),
    buildingFoundationComplianceId: yup
        .number()
        .min(1, "Building Foundation Compliance is required")
        .required("Building Foundation  Compliance is required")
        .typeError("Building Foundation  Compliance is required"),
    buildingFoundation: yup.string().nullable(true)
    .when("buildingFoundationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Building Foundation(ft) should be numeric")
        .required("Building Foundation(ft) is required")
    }),
    buildingFoundationComment: yup.string().nullable(true)
        .when("buildingFoundationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Building Foundation Comment is required")
                .typeError("Building Foundation Comment is required"),
        }),
    propertyLinesComplianceId: yup
        .number()
        .min(1, "Property Lines Compliance is required")
        .required("Property Lines Compliance is required")
        .typeError("Property Lines Compliance is required"),
    propertyLines: yup.string().nullable(true)
    .when("propertyLinesComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Property Lines(ft) should be numeric")
        .required("Property Lines(ft) is required")
    }),
    propertyLinesComment: yup.string()
        .nullable(true)
        .when("propertyLinesComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Property Lines Comment is required")
                .typeError("Property Lines Comment is required"),
        }),
    otherComplianceId: yup
        .number()
        .min(1, "Other Compliance is required")
        .required("Other Compliance is required")
        .typeError("Other Compliance is required"),

    otherSetback: yup.string().nullable(true)
    .when("otherComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.string()
        .typeError("Other(ft) should be numeric")
        .required("Other(ft) is required")
    }),

});

